export default "__VITE_ASSET__GRI8zV24__"